var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKda(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#tokenBrandedKda0)",
    d: "M18.306 18.857h-4.245l-4.354-6.204l1.742-3.591z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6A0097",
    d: "M5.571 5.143H9v13.714H5.57z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#tokenBrandedKda1)",
    d: "M17.544 5.143h-3.918L9 9.857v4.284z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "tokenBrandedKda0",
    x1: 15.314,
    x2: 8.236,
    y1: 18.857,
    y2: 8.875,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A0097"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E40790"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tokenBrandedKda1",
    x1: 16.286,
    x2: 8.571,
    y1: 5.143,
    y2: 12.214,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#730196"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED098F"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKda);
export default __webpack_public_path__ + "static/media/kda.f42ee6505adef33b52b4dd2a553cfeec.svg";
export { ForwardRef as ReactComponent };